import Axios from 'axios'
import React, { useEffect, useState } from 'react'
import { toAbsoluteUrl } from '../../_metronic/_helpers'
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../_metronic/_partials/controls'
import { useSnackbar } from "notistack";


export default function Shopify() {
    const { enqueueSnackbar } = useSnackbar();
    const [free,setFree] = useState('');
    const [disabled, setDisabled] = useState(false);

    useEffect(()=>
    {
        const getMessage = async()=>
        {
            const res = await Axios.get("https://node.ccdemostore.com/admin/api/v1/cron/get_products_sync_cron");
            
            setFree(res && res.data & res.data.status)
            if(res.data.data.status===0){
                setDisabled(false)
            }else
            setDisabled(true)
        }
       
        getMessage();


    },[])

    const onHandleShopifySync = async () => {
        if(!disabled){
            const res = await Axios.get("https://node.ccdemostore.com/admin/api/v1/cron/products_sync");
            if (res.data.success) {
                await enqueueSnackbar(res.data.data, {
                    variant: "success",
                });
            } else {
                await enqueueSnackbar(res.data.message, {
                    variant: "danger",
                });
            }
        }
       
    }
    return (
        <Card>
            <CardHeader title={<span style={{ marginRight: '5px' }}>
                <img src={toAbsoluteUrl("/media/platforms/shopify.png")} alt="" title="Shopify Portal" height="32" width="32"></img>Shopify - Products Sync
            </span>}>
                <CardHeaderToolbar>
                </CardHeaderToolbar>
            </CardHeader>{" "}
            <CardBody>
                <span
                    className='btn btn-outline-primary my-3'
                    href=''
                    onClick={onHandleShopifySync}
                    disabled={disabled}
                    style={disabled?{cursor:'not-allowed'}:{}}
                >
                    <i class="fa fa-angle-right" aria-hidden="true"></i> ProductSync
                </span><br />{disabled && <b> Cron is Busy now !! </b>}
            </CardBody>
        </Card>
    )
}
